import { config } from "../../config";
import { networkLayer } from "../../api/networkLayer";
import {
  AnonymousHolterUploadIdentifier,
  AnonymousUploadPart,
  AnonymousSmallFileUploadUrlResponse,
  UploadAnonymousHolterFileV2Options,
} from "./types";

export const buildIdentifierPayload = ({ serialNumber, sharableCode }: AnonymousHolterUploadIdentifier) => {
  if (serialNumber) return { serial_number: serialNumber };
  if (sharableCode) return { sharable_code: sharableCode };

  throw new Error("serialNumber or sharableCode is required");
};

export const initAnonymousHolterUploadV2 = async ({
  serialNumber,
  sharableCode,
  file,
  origin,
}: UploadAnonymousHolterFileV2Options) => {
  return await networkLayer(
    "post",
    `${config.dataUrls}/measurement/holter/anonymous/v2/temporal_credentials/`,
    {
      ...buildIdentifierPayload({ serialNumber, sharableCode }),
      file_size: file.size,
      origin: origin || window.location.origin,
    }
  );
};

export const requestAnonymousSmallFileUploadUrlV2 = async ({
  serialNumber,
  sharableCode,
  filename,
}: AnonymousHolterUploadIdentifier & { filename: string }) => {
  return await networkLayer(
    "post",
    `${config.dataUrls}/measurement/holter/anonymous/v2/small_file_upload_url/`,
    {
      ...buildIdentifierPayload({ serialNumber, sharableCode }),
      filename,
    }
  ) as { data: AnonymousSmallFileUploadUrlResponse };
};

export const listAnonymousHolterMultipartLinksV2 = async ({
  serialNumber,
  sharableCode,
  uploadId,
  chunksNumber,
}: AnonymousHolterUploadIdentifier & { uploadId: string; chunksNumber: number }) => {
  return await networkLayer(
    "post",
    `${config.dataUrls}/measurement/holter/anonymous/v2/list_multipart_links/`,
    {
      ...buildIdentifierPayload({ serialNumber, sharableCode }),
      upload_id: uploadId,
      chunks_number: chunksNumber,
    }
  );
};

export const finishAnonymousHolterUploadV2 = async ({
  serialNumber,
  sharableCode,
  uploadId,
  chunksNumber,
  parts,
}: AnonymousHolterUploadIdentifier & {
  uploadId: string;
  chunksNumber?: number;
  parts?: AnonymousUploadPart[];
}) => {
  return await networkLayer(
    "post",
    `${config.dataUrls}/measurement/holter/anonymous/v2/finish_multipart_upload/`,
    {
      ...buildIdentifierPayload({ serialNumber, sharableCode }),
      upload_id: uploadId,
      ...(chunksNumber ? { chunks_number: chunksNumber } : {}),
      ...(parts ? { parts } : {}),
    }
  );
};
